import { AxiosInstance } from 'axios';

/**
 * Who the API thinks you are.
 *
 * Kept apart from api.ts because that file is generated by nswag and gets overwritten on
 * the next generation. The axios instance was created with transformResponse: [], so
 * response.data is a string and has to be parsed here.
 */

export interface Identity {
    /** Display name from the token, empty when it carries none. */
    name?: string | null;
    /** `Admin`, or the customers this account may look at. */
    roles: string[];
    /** Whether this account sees more than the error log of an environment. */
    isAdmin: boolean;
}

const parse = <T,>(data: any): T =>
    typeof data === 'string' ? (JSON.parse(data) as T) : (data as T);

/**
 * Asks the API what the access token says about the caller.
 *
 * The same claims are inside the token this browser already holds, so the roles could be
 * read straight out of it. They are asked for instead, because the answer decides what the
 * screen offers and the API decides what it hands over: two readings of one token that must
 * not be able to disagree. This way the claim name and its shape live in one place.
 */
export const getIdentity = async (axios: AxiosInstance): Promise<Identity> => {
    const response = await axios.get('/Identity');

    const identity = parse<Identity>(response.data);

    return { ...identity, roles: identity.roles ?? [] };
};
